import { Button, Css, ModalBody, ModalFooter, ModalHeader, SelectField, Switch, useModal } from "@homebound/beam";
import { useState } from "react";
import { baseDownloadUrl } from "src/context";
import { DesignPackageLocation } from "src/generated/graphqlTypes";
import { ProjectFinishScheduleMetadataQuery } from "src/routes/projects/finish-schedule/ProjectFinishSchedulePage.generated";
import { openInSelf } from "src/utils/window";

type ExportProjectFinishScheduleModalProps = {
  project: ProjectFinishScheduleMetadataQuery["project"];
  splitExportEnabled: boolean;
};

export function ExportProjectFinishScheduleModal(props: ExportProjectFinishScheduleModalProps) {
  const { project, splitExportEnabled } = props;
  const { closeModal } = useModal();
  const [visualMode, setVisualMode] = useState(false);
  const [location, setLocation] = useState<DesignPackageLocation | undefined>(undefined);

  return (
    <>
      <ModalHeader>Export Finish Schedule for ‘{project.name}’</ModalHeader>
      <ModalBody>
        <div css={Css.df.fdc.my1.gap2.$}>
          {splitExportEnabled && (
            <SelectField
              label="Choose Finish Schedule Type"
              placeholder="Select a type"
              options={[
                { code: DesignPackageLocation.Interior, name: "Interior" },
                { code: DesignPackageLocation.Exterior, name: "Exterior" },
              ]}
              value={location}
              onSelect={setLocation}
              autoSort={false}
            />
          )}
          <Switch compact label="Visual Mode" selected={visualMode} onChange={setVisualMode} />
        </div>
      </ModalBody>
      <ModalFooter>
        <div css={Css.df.gap2.$}>
          <Button variant="quaternary" label="Cancel" onClick={closeModal} />
          <Button
            variant="primary"
            label="Export"
            disabled={splitExportEnabled && !location && "Select a finish schedule type to export"}
            onClick={() => {
              openInSelf(
                `${baseDownloadUrl()}/${visualMode ? "pdf" : "xlsx"}?${buildQueryParams(visualMode, project.id, location)}`,
              );
              closeModal();
            }}
          />
        </div>
      </ModalFooter>
    </>
  );
}

function buildQueryParams(
  visualMode: boolean,
  projectId: string,
  designPackageLocation: DesignPackageLocation | undefined,
) {
  // build the query params for the PDF download url
  const params = new URLSearchParams({
    projectId,
    type: visualMode ? "projectFinishScheduleVisualMode" : "lfsFinishSchedule",
    ...(designPackageLocation && { designPackageLocation }),
  });
  return params.toString();
}
